import { TranslationRepository } from '../data/translation-repository';
import { ApplicationType, ExportResponse } from '../types/translation-types';

export class DownloadTemplateUseCase {
  constructor(private readonly repository: TranslationRepository) {}

  async execute(applicationType: ApplicationType): Promise<ExportResponse> {
    return this.repository.downloadTemplate(applicationType);
  }
}
